import { render, staticRenderFns } from "./VehicleCategorySetupModal.vue?vue&type=template&id=10db96d8&scoped=true&"
import script from "./VehicleCategorySetupModal.vue?vue&type=script&lang=js&"
export * from "./VehicleCategorySetupModal.vue?vue&type=script&lang=js&"
import style0 from "./VehicleCategorySetupModal.vue?vue&type=style&index=0&id=10db96d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10db96d8",
  null
  
)

export default component.exports